import { format } from 'date-fns'

export function formatDate(date: Date | string | number) {
  return format(date, 'MMMM D YYYY')
}



// WEBPACK FOOTER //
// ./src/lib/helpers/time.ts